import { create } from 'zustand';

interface CommandPaletteState {
	open: boolean;
	setOpen: (open: boolean) => void;
	toggle: () => void;
}

/** Open/close state for the ⌘K command palette, shared between the topbar trigger,
 * the global key binding (in app-shell), and the dialog — without prop-drilling. */
export const useCommandPaletteStore = create<CommandPaletteState>((set, get) => ({
	open: false,
	setOpen: open => set({ open }),
	toggle: () => set({ open: !get().open })
}));
